import * as _ from '../gleam.mjs'
import * as storage from './storage.mjs'

export const length = storage_ => selectStorage(storage_).length

export function key(storage_, key) {
  const k = selectStorage(storage_).key(key)
  if (k === null) return _.Result$Error(storage.StorageError$MissingKeyError())
  return _.Result$Ok(k)
}

export function getItem(storage_, key) {
  const v = selectStorage(storage_).getItem(key)
  if (v === null) return _.Result$Error(storage.StorageError$MissingKeyError())
  return _.Result$Ok(v)
}

export function getJson(storage_, key) {
  try {
    const v = selectStorage(storage_).getItem(key)
    if (v === null)
      return _.Result$Error(storage.StorageError$MissingKeyError())
    const dyn = JSON.parse(v)
    return _.Result$Ok(dyn)
  } catch (_error) {
    const err = storage.StorageError$InvalidJsonError()
    return _.Result$Error(err)
  }
}

export function removeItem(storage_, key) {
  selectStorage(storage_).removeItem(key)
}

export function setItem(storage_, key, value) {
  try {
    selectStorage(storage_).setItem(key, value)
    return _.Result$Ok(value)
  } catch (_error) {
    const err = storage.StorageError$QuotaExceededError()
    return _.Result$Error(err)
  }
}

export function clear(storage_) {
  selectStorage(storage_).clear()
}

function selectStorage(storage_) {
  if (storage.Storage$isSession(storage_)) return sessionStorage
  if (storage.Storage$isLocal(storage_)) return localStorage
}
